import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { CurrentDataModel } from './current-data.state';

export class ClearCurrentData implements ExecutableAction<CurrentDataModel> {
  static readonly type = '[Current Data] Clear Current Data';

  execute(params: ExecutableActionParam<CurrentDataModel>) {
    params.ctx.setState({
      recordLoaded: false,
      record: null,
      usagesInfo: null,
    });
  }
}
